/**
 * GTM's consent processor expects the native `arguments` object pushed to dataLayer,
 * not a plain array. Rest params (`...args`) produce an array that GTM ignores.
 */

/* eslint-disable prefer-rest-params */

export function gtag(command: string, action: string, params: Record<string, unknown>): void;
export function gtag() {
  window.dataLayer ??= [];

  window.dataLayer.push(arguments);
}
